import React, {useEffect, useState, useRef} from "react";
import {
    Button,
    Container,
    Dialog,
    Grid, Typography,
    Paper, Box, TextField, IconButton
} from "@mui/material";
import Divider from '@mui/material/Divider';
// DataGrid v6: 미사용 GridCellValue/GridSelectionModel 제거
import {DataGrid, GridColDef} from '@mui/x-data-grid';
import {mappingBaseInterface,
    mappingLRSInterface,
    mappingBaseInitial} from '../../../api/definition';
import {UploadConfigPreview} from '../../../api/configAPI';
import {StartUploadProcess} from '../../../api/processAPI';
import {UploadTestProcess} from '../../../api/testAPI';
import {UploadHistoryList, HistoryUploadListArrayType} from '../../../api/historyAPI';
import {HistoryLoading} from '../../Layout/Loading';
import UploadShowError from '../../Error/UploadShowError';
import SamplePreview from '../../BoxComponent/UploadSamplePreviewBox';
import {ConfirmDialog} from "../../Layout/CustomDialog";
import RefreshIcon from "@mui/icons-material/Refresh";

// 파일 업로드 컴포넌트
function FileUploadSection(props: any){

    return (
 <Grid container spacing={1} sx={{mb:2}}>
            <Grid container item spacing={1}>
                <Paper sx={{
                    p:3,
                    width:'100%',
                    mt:2,
                    bgcolor:'#eeeeee'
                }}>
                <Grid container item spacing={1}>
                    <Typography variant='h6'>▣ 파일 업로드</Typography>
                </Grid>
                <Grid container item spacing={1} sx={{mt:3}}>
                    <Paper elevation={2} sx={{p:1, pb:0,  width:'100%'}}>
                        <Grid container item spacing={1} sx={{borderBottom: '1px solid #ccc'}}>
                            <Grid item md={1} sm={1} xs={1} lg={1} sx={{bgcolor:'primary.main',
                                                                        display:'flex',
                                                                        alignItems: 'center'}}>
                                <Typography variant="subtitle2" sx={{color: '#ffffff', fontWeight:'bold'}}>STEP1</Typography>
                            </Grid>
                            <Grid item md={9} sm={9} xs={9} lg={9}
                                  sx={{display:'flex',
                                  flexDirection: 'row',
                                  alignItems: 'center',
                                  height:'100%'}}>
                                <Typography>※ 업로드 할 파일의 샘플 양식을 확인해주세요!!</Typography>
                                <Button variant='contained'
                                        sx={{ml:3, mb:1}}
                                        onClick={props.handleUploadSamplePreview}>샘플양식 미리보기</Button>
                            </Grid>
                        </Grid>
                        <Grid container item spacing={1} >
                            <Grid item md={1} sm={1} xs={1} lg={1} sx={{bgcolor:'primary.main',
                                                                        display:'flex',
                                                                        alignItems: 'center', mt:1}}>
                                <Typography variant="subtitle2" sx={{color: '#ffffff', fontWeight:'bold'}}>STEP2</Typography>
                            </Grid>
                            <Grid item md={9} sm={9} xs={9} lg={9}
                                  sx={{
                                  flexDirection: 'row',
                                  alignItems: 'center',
                                  height:'100%'}}>
                                <Box>
                                    <Typography sx={{ mt:1, mb: 1 }}>
                                        ※ 업로드 파일은 반드시 확장자가 “csv, xls, xlsx” 파일이어야 합니다!!<br />
                                      ※ 업로드 된 데이터는 기존 데이터를 덮어쓰기합니다. 신규데이터는 추가됩니다.<br />
                                      ※ 한번 업로드 된 데이터는 삭제되지 않습니다. 업로드 시, 데이터를 확인 후 업로드해주세요.
                                    </Typography>
                                </Box>
                                <Box sx={{
                                    mt:2,
                                    display:'flex',
                                  flexDirection: 'row',
                                  alignItems: 'center',
                                  height:'100%'}}>
                                    <TextField
                                        disabled
                                        id="upload_file"
                                        label="File Name"
                                        size="small"
                                        value={props.filename}>

                                    </TextField>
                                     <input
                                        type="file"
                                        accept=".csv,.xlsx,.json"
                                        style={{ display: "none" }}
                                        ref={props.fileInputRef}
                                        onChange={props.handleFileChange}
                                     />
                                    <Button variant='contained'
                                        sx={{ml:1, mb:1}}
                                        onClick={props.handleClick}
                                    >파일 선택하기</Button>
                                </Box>
                                <Box sx={{
                                    mt: 1, mb:1,
                                    display:'flex',
                                  flexDirection: 'row',
                                  alignItems: 'center',
                                  height:'100%'}}>
                                    <Typography>
                                        구분기호
                                    </Typography>
                                    <TextField
                                        id="upload_sep"
                                        label="Spliter"
                                        size="small"
                                        value={props.fileSeparate}
                                        onChange={e => props.setFileSeparate(e.target.value)}
                                        sx={{ml: 2}}>
                                    </TextField>
                                </Box>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
                </Paper>
                <Grid container item spacing={1} justifyContent="center" textAlign="center"
                        sx={{ mt:1}}>
                    <Button variant='contained' 
                            sx={{ml:1}}
                            onClick={props.handleStartOpen}>업로드
                    </Button>
                    <Button variant='contained'
                            sx={{ml:1}}
                        onClick={props.handleUploadTestStart}>테스트
                    </Button>
                    <Button variant='outlined'
                            sx={{ml:1}}>취소
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    );
}

// 이력 관리 컴포넌트
function FileUploadHistorySection(props: any){

    // 샘플 컬럼 정의
    const uploadHistoryColumns: GridColDef[] = [
      { field: 'id' },
      {
        field: 'rownum', headerName: 'No', flex: 1, sortable: false, filterable: false,
        align: 'center', headerAlign: 'center',
        renderCell: (params) => {
            // v6: getRowsCount/getRowIndex 제거 → getAllRowIds 로 전체 기준 역순 번호 유지
            const allIds = params.api.getAllRowIds();
            const totalCount = allIds.length;
            const currentIndex = allIds.indexOf(params.id);
            return totalCount - currentIndex;
        }
      },
      { field: 'filename', headerName: '업로드 파일명', flex:4 ,align: 'center', headerAlign: 'center'},
      { field: 'start', headerName: '업로드 일시', flex: 3 ,align: 'center', headerAlign: 'center'},
      { field: 'total_count', headerName: '총 건수', flex: 1 ,align: 'center', headerAlign: 'center'},
      { field: 'success_count', headerName: '성공', flex: 1 ,align: 'center', headerAlign: 'center'},
      { field: 'failure_count', headerName: '실패', flex: 1 ,align: 'center', headerAlign: 'center'},
      { field: 'status', headerName: '상태', flex: 1 ,align: 'center', headerAlign: 'center'},
      {
        field: 'error', headerName: '에러', flex: 1, sortable: false, filterable: false ,align: 'center', headerAlign: 'center',
        renderCell: (params) => {
          const errorMsg = params.row.error;
          return errorMsg && errorMsg.trim() !== '' ? (
            <Button
              variant="outlined"
              size="small"
              color="error"
              onClick={() => props.handleShowErrorMsg(params.row.error)}
            >
              에러 보기
            </Button>
          ) : null;
        }
      }
    ];

    return (
        <Grid container spacing={1} sx={{mt:1}}>
            <Grid container item spacing={1}>
                <Paper sx={{
                    p:3,
                    width:'100%',
                    mt:2,
                    bgcolor:'#eeeeee'
                }}>
                <Grid container item spacing={1}>
                    <Typography variant='h6'>▣ 이력관리</Typography>
                    <IconButton
                        aria-label='refresh'
                        onClick={props.handleFileHistoryReset}
                        sx={{pt:0, pb:0}}
                    >
                        <RefreshIcon/>
                    </IconButton>
                </Grid>
                <Grid container item spacing={1} sx={{ mt:1}}>
                    <Paper sx={{
                        p:1,
                        display:'flex',
                        height:380,
                        width:'100%'
                    }}>
                        {props.historyLoading ?
                            <HistoryLoading />
                            :
                        <DataGrid columns={uploadHistoryColumns} rows={props.historyData}
                                  // 레이아웃: flex 부모에서 폭 0 방지(정적 정렬)
                                  sx={{ flex: 1, minWidth: 0 }}
                                  // v6: hide 제거 → columnVisibilityModel + 비제어 페이지네이션 초기값
                                  initialState={{ columns: { columnVisibilityModel: { id: false } }, pagination: { paginationModel: { pageSize: 5, page: 0 } } }}
                                  pageSizeOptions={[5]}
                        autoHeight/>
                        }
                    </Paper>
                </Grid>
                </Paper>
            </Grid>
        </Grid>
   );
}


// 메인 팝업
function ProcessUploadConfigDialog(props: any) {
    const [fileName, setFileName] = useState<string>("");
    const [file, setFile] = useState<File | null>(null);
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const [fileSeparate, setFileSeparate] = useState<string>("");
    const [previewOpen, setPreviewOpen] = useState<boolean>(false);
    const [previewList, setPreviewList] = useState<Array<mappingBaseInterface> | mappingLRSInterface>([mappingBaseInitial()]);
    const [startOpen, setStartOpen] = useState<boolean>(false);
    const [historyLoading, setHistoryLoading] = useState<boolean>(false);
    const [historyData, setHistoryData] = useState<HistoryUploadListArrayType>([]);
    const [errorViewOpen, setErrorViewOpen] = useState<boolean>(false);
    const [errorMsg, setErrorMsg] = useState<string>('');
    const [refreshHistoryFlag, setRefreshHistoryFlag] = useState<boolean>(false);

    useEffect(() => {
        setHistoryLoading(true);
        UploadHistoryList().then(value => {
            setHistoryData(value.data);
            setHistoryLoading(false);
        });
    }, [refreshHistoryFlag])

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const selectedFile = event.target.files?.[0];
        if (selectedFile) {
          setFileName(selectedFile.name);
          setFile(selectedFile);
        }
      };

    const handleClick = () => {
        fileInputRef.current?.click(); // 숨겨진 input을 클릭
    };

    const hanleDialogClose = () => {
        setFileName('');
        setFile(null);
        setFileSeparate('');
        props.handleUploadProcessClose();
    }

    const handleUploadSamplePreview = () => {
        UploadConfigPreview(props.uploadProcessName.name, props.uploadProcessName.writer).then(value => {
            setPreviewOpen(true);
            setPreviewList(value);

        })
    }

    const handleUploadSamplePreviewClose = () => {
        setPreviewOpen(false);
        setPreviewList([mappingBaseInitial()]);
    }

    const handleStartOpen = () => {
        setStartOpen(true);
    }

    const handleStartClose = () => {
        setStartOpen(false);
    }

    const handleStart = () => {
        setStartOpen(false);
        if(fileName === '' || file === null){
            alert("파일을 등록해주세요.");
        }else {
            const uploadFormData = new FormData();
            uploadFormData.append('file', file);
            uploadFormData.append('configname', props.uploadProcessName.name);
            uploadFormData.append('writer', props.uploadProcessName.writer);
            uploadFormData.append('separate', fileSeparate);

            StartUploadProcess(uploadFormData).then(value => {
                alert(value);
                setRefreshHistoryFlag(prev => !prev);
            });
        }

    }

    const handleUploadTestStart = () => {
        if(fileName === '' || file === null){
            alert("파일을 등록해주세요.");
        }else {
            const uploadFormData = new FormData();
            uploadFormData.append('file', file);
            uploadFormData.append('configname', props.uploadProcessName.name);
            uploadFormData.append('writer', props.uploadProcessName.writer);
            uploadFormData.append('separate', fileSeparate);

            props.setTestOpen(true);
            props.setTestLoading(true);
            UploadTestProcess(uploadFormData).then(value => {
                if (value[0].error) {
                    props.setTestResult(value);
                    props.setTestResultName('');
                    props.setTestResultTime('');
                    props.setTestResultContent(value[0]['result']);
                    props.setTestResultError(value[0].error);
                    props.setTestLoading(false);
                } else {
                    props.setTestResult(value);
                    props.setTestResultName(value[0]['name']);
                    props.setTestResultTime(value[0]['time']);
                    props.setTestResultContent(value[0]['result']);
                    props.setTestResultError(value[0].error);
                    props.setTestLoading(false);
                }
            });
        }
    }

    const handleShowErrorMsg = (errMsg: string) => {
        setErrorMsg(errMsg);
        setErrorViewOpen(true);
    }

    const handleShowErrorMsgClose = () => {
        setErrorMsg('');
        setErrorViewOpen(false);
    }

    const handleFileHistoryReset = () => {
        setRefreshHistoryFlag(prev => !prev);
    }


    return (
        <Dialog open={props.open}
                maxWidth='xl'
                fullWidth
        >
            <Container maxWidth='xl' sx={{mt:2, mb:2}}>
                <Grid container spacing={1}>
                    <Grid item lg={10} md={10} sm={10} xs={10}>
                        <Typography variant='h6'>
                            파일 업로드 및 이력관리
                        </Typography>
                    </Grid>
                    <Grid item lg={2} md={2} sm={2} xs={2} sx={{textAlign:'right'}}>
                        <Button
                            size="small"
                            variant='contained'
                            onClick={hanleDialogClose}
                            sx={{mb:1}}
                        >
                            닫기
                        </Button>
                    </Grid>
                </Grid>
                <Divider />
                <FileUploadSection fileInputRef={fileInputRef} handleFileChange={handleFileChange}
                            handleClick={handleClick} filename={fileName}
                            setFileSeparate={setFileSeparate} fileSeparate={fileSeparate}
                            handleUploadTestStart={handleUploadTestStart}
                            handleUploadSamplePreview={handleUploadSamplePreview}
                            handleStartOpen={handleStartOpen}> </FileUploadSection>
                <Divider />
                <FileUploadHistorySection historyData={historyData}
                                        historyLoading={historyLoading}
                                          handleShowErrorMsg={handleShowErrorMsg}
                                          handleFileHistoryReset={handleFileHistoryReset}
                ></FileUploadHistorySection>

            </Container>
           <ConfirmDialog
                open={startOpen}
                handleDialogAction={handleStart}
                handleDialogClose={handleStartClose}
                title={'Start Upload Process'}
                text={'선택한 파일을(를) 정말로 업로드하시겠습니까?'}
            />
        {previewOpen && (
          <SamplePreview
            open={previewOpen}
            previewList={previewList}
            handleUploadSamplePreviewClose={handleUploadSamplePreviewClose}
          />
        )}
            {errorViewOpen && (
                <UploadShowError
                errorViewOpen={errorViewOpen}
                errorMsg={errorMsg}
                handleShowErrorMsgClose={handleShowErrorMsgClose}>
                </UploadShowError>
            )

            }
        </Dialog>

    )
}

export default ProcessUploadConfigDialog